/* eslint-disable @typescript-eslint/lines-between-class-members */
export default class QueryParams {
    static readonly JobAdId = 'jobAdId';
    static readonly RecruitmentId = 'recruitmentId';
    static readonly ApplicantId = 'applicantId';
}
